/* 2026-10-20 · videos del problema como imagen animada en bucle: el iPhone en bajo consumo no reproduce <video> solo */
try{(function(){var U={'nvp-p-choque.mp4':'https://cdn.shopify.com/s/files/1/0672/5081/5125/files/nvp-p-choque.webp?v=1792539079','nvp-p-raponazo-30.mp4':'https://cdn.shopify.com/s/files/1/0672/5081/5125/files/nvp-p-raponazo-30.webp?v=1792539080'};
document.querySelectorAll('.pb-v video').forEach(function(v){var k=Object.keys(U).find(function(n){return (v.getAttribute('src')||'').indexOf(n)>-1;});if(!k)return;
var i=new Image();i.src=U[k];i.alt=v.getAttribute('aria-label')||'';i.decoding='async';i.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:'+(v.closest('.pb-vert')?'100% 50%':'50% 50%');v.replaceWith(i);});})()}catch(e){console.error(e)}
try {

(() => {
  if (!('IntersectionObserver' in window)) { document.documentElement.classList.remove('js'); return; }
  const ver = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('vis'); ver.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.rv').forEach(el => ver.observe(el));
  const barra = document.querySelector('.barra'), hero = document.querySelector('.hero .btn'), ofe = document.getElementById('oferta'), ped = document.getElementById('pedir');
  let a = true, b = false, c = false; const up = () => barra.classList.toggle('oculta', a || b || c);
  new IntersectionObserver(es => { a = es[es.length - 1].isIntersecting; up(); }).observe(hero);
  new IntersectionObserver(es => { b = es[es.length - 1].isIntersecting; up(); }).observe(ofe);
  new IntersectionObserver(es => { c = es[es.length - 1].isIntersecting; up(); }).observe(ped);
})();

} catch (e) { console.error(e); }
try {

document.querySelectorAll('[data-car]').forEach(c => {
  const t = c.querySelector('.car-track'), sl = [...t.children], d = c.querySelector('.car-dots');
  sl.forEach(() => d.appendChild(document.createElement('i')));
  const dots = [...d.children];
  const upd = () => { const x = t.scrollLeft + t.clientWidth / 2; let k = 0, best = 1e9; sl.forEach((e, n) => { const m = Math.abs(e.offsetLeft + e.offsetWidth / 2 - x); if (m < best) { best = m; k = n; } }); dots.forEach((e, n) => e.classList.toggle('on', n === k)); };
  t.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true }); upd();
  c.querySelectorAll('.car-btn').forEach(b => b.addEventListener('click', () => t.scrollBy({ left: b.dataset.dir * (sl[0].offsetWidth + 12), behavior: 'smooth' })));
});

} catch (e) { console.error(e); }
try {

// Modelo 5" o 6": los dos selectores (portada y pedido) y la barra van sincronizados.
// Si el enlace del anuncio trae ?modelo=6, la página abre con el de 6" elegido.
(() => {
  const PR = { '5': '$299.999', '6': '$450.000' };
  const cards = [...document.querySelectorAll('.nv-op[data-var]')], radios = [...document.querySelectorAll('input[name="var"]')], barra = document.querySelector('.nv-barra-pr');
  const pick = v => {
    cards.forEach(c => { const on = c.dataset.var === v; c.classList.toggle('on', on); c.setAttribute('aria-checked', on); });
    radios.forEach(r => { r.checked = r.value === v; });
    if (barra) barra.textContent = PR[v];
    const duo = document.querySelector('.nv-duo'); if (duo) duo.dataset.on = v;
    const m = document.querySelector('.nv-modelo'); if (m) m.textContent = v === '6' ? 'Power DVR NavPro 6"' :'Power NavPro 5"';
    document.dispatchEvent(new CustomEvent('nv:modelo', { detail: v }));
  };
  cards.forEach(c => c.addEventListener('click', () => pick(c.dataset.var)));
  radios.forEach(r => r.addEventListener('change', () => pick(r.value)));
  const q = new URLSearchParams(location.search).get('modelo') && null; // v49: solo 5"
  pick(q === '6' ? '6' : '5');
})();

} catch (e) { console.error(e); }
try {

// Releasit (contraentrega) en modo ventana, con su botón flotante escondido: cualquier botón que lleve a #pedir lo abre.
// Si Releasit aún no cargó, el enlace baja a #pedir. Igual que en el inmovilizador.
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#pedir"]');
  if (!a) return;
  var b = document.getElementById('rsi_buy_now_button');
  if (b) { e.preventDefault(); b.click(); }
});
// Pendiente al montar en Shopify: pasar el modelo elegido a la variante del producto (5" o 6").

} catch (e) { console.error(e); }
try {

(() => {
  const barra = document.querySelector('.progreso span'); if (!barra) return;
  let pend = false;
  const pintar = () => { pend = false; const max = document.documentElement.scrollHeight - innerHeight; barra.style.transform = `scaleX(${max > 0 ? Math.min(scrollY / max, 1) : 0})`; };
  addEventListener('scroll', () => { if (!pend) { pend = true; requestAnimationFrame(pintar); } }, { passive: true });
  addEventListener('resize', pintar); pintar();
})();

} catch (e) { console.error(e); }
try {

// Pantalla viva: encaja un div de 424×300 en las 4 esquinas reales de la pantalla de la foto (homografía → matrix3d).
(() => {
  const scr = document.querySelector('.nv-scr'), img = document.querySelector('.nv-duo img[data-var="5"]'), duo = document.querySelector('.nv-duo');
  if (!scr || !img || !duo) return;
  duo.appendChild(scr);
  const Q = [[112,96],[663,96],[663,397],[112,397]], IW = 776, IH = 464, W = 550, H = 300; // esquinas en la foto original
  function adj(m){return[m[4]*m[8]-m[5]*m[7],m[2]*m[7]-m[1]*m[8],m[1]*m[5]-m[2]*m[4],m[5]*m[6]-m[3]*m[8],m[0]*m[8]-m[2]*m[6],m[2]*m[3]-m[0]*m[5],m[3]*m[7]-m[4]*m[6],m[1]*m[6]-m[0]*m[7],m[0]*m[4]-m[1]*m[3]];}
  function mul(a,b){const c=[];for(let i=0;i<3;i++)for(let j=0;j<3;j++){let s=0;for(let k=0;k<3;k++)s+=a[3*i+k]*b[3*k+j];c[3*i+j]=s;}return c;}
  function mv(m,v){return[m[0]*v[0]+m[1]*v[1]+m[2]*v[2],m[3]*v[0]+m[4]*v[1]+m[5]*v[2],m[6]*v[0]+m[7]*v[1]+m[8]*v[2]];}
  function basis(p){const m=[p[0][0],p[1][0],p[2][0],p[0][1],p[1][1],p[2][1],1,1,1];const v=mv(adj(m),[p[3][0],p[3][1],1]);return mul(m,[v[0],0,0,0,v[1],0,0,0,v[2]]);}
  function fit(){
    if (duo.dataset.on !== '5') { scr.classList.remove('on'); return; }
    const fr = duo.getBoundingClientRect(), r = img.getBoundingClientRect(), sx = r.width / IW, sy = r.height / IH;
    if (!img.complete || r.width < 40 || getComputedStyle(img).opacity < .9 || !duo.classList.contains('giro-ok')) { setTimeout(fit, 250); return; }
    const dst = Q.map(([x,y]) => [r.left - fr.left + x*sx, r.top - fr.top + y*sy]);
    const src = [[0,0],[W,0],[W,H],[0,H]];
    const t = mul(basis(dst), adj(basis(src)));
    const m = t.map(v => v / t[8]);
    scr.style.transform = `matrix3d(${m[0]},${m[3]},0,${m[6]},${m[1]},${m[4]},0,${m[7]},0,0,1,0,${m[2]},${m[5]},0,1)`;
    if (!scr.classList.contains('on')) { scr.classList.add('boot'); clearTimeout(scr._b); scr._b = setTimeout(() => { scr.classList.remove('boot'); scr.dataset.app = 'mapa'; duo.classList.add('hs-on'); scr.classList.add('splash'); setTimeout(() => scr.classList.remove('splash'), 1300); clearTimeout(scr._c); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) (function ciclo(){ const ORD = ['mapa','musica','llamada','llantas'], DUR = { mapa: 6800, musica: 3000, llamada: 4600, llantas: 4200 };
          scr._c = setTimeout(() => { const sig = ORD[(ORD.indexOf(scr.dataset.app) + 1) % ORD.length]; if (sig === 'llamada') scr.dispatchEvent(new Event('nv:llamada')); scr.dataset.app = sig;
            if (sig === 'mapa') { scr.classList.add('splash'); setTimeout(() => scr.classList.remove('splash'), 1300); }
            if (sig === 'llantas') { scr.classList.remove('ll-fin'); scr.querySelectorAll('.ll-dato b').forEach(b => { const to = +b.dataset.to, t0 = performance.now(); const paso = t => { const k = Math.min((t - t0) / 1200, 1); b.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(paso); else scr.classList.add('ll-fin'); }; requestAnimationFrame(paso); }); }
            ciclo(); }, DUR[scr.dataset.app] || 3000); })(); }, 1300); }
    scr.classList.add('on');
  }
  addEventListener('resize', fit); img.addEventListener('transitionend', fit); img.addEventListener('load', fit);
  document.addEventListener('nv:modelo', () => { scr.classList.remove('on'); setTimeout(fit, 850); });
  setTimeout(fit, 950); fit();
})();

} catch (e) { console.error(e); }
try {

// Etiquetas técnicas: aparecen cuando termina el arranque de la pantalla. Parallax suave del producto al bajar.
(() => {
  const duo = document.querySelector('.nv-duo'); if (!duo) return;
  setTimeout(() => duo.classList.add('hs-on'), 6000); // respaldo: normalmente salen al entrar CarPlay
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { duo.classList.add('hs-on'); return; }
  let pend = false;
  addEventListener('scroll', () => { if (pend) return; pend = true; requestAnimationFrame(() => { pend = false; const y = Math.min(scrollY, 700); duo.style.translate = `0 ${y * .12}px`; }); }, { passive: true });
})();

} catch (e) { console.error(e); }
try {

// v24: transformación. La foto de lado (pantalla apagada) se convierte en la frontal: la frontal arranca deformada en
// perspectiva con sus 4 esquinas de pantalla exactamente sobre las de la foto de lado y se endereza cuadro a cuadro.
(() => {
  const duo = document.querySelector('.nv-duo'), img = duo && duo.querySelector('img[data-var="5"]'); if (!img) return;
  const listo = () => { if (duo.classList.contains('giro-ok')) return; img.style.removeProperty('transform'); duo.classList.add('giro-ok'); };
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { duo.classList.add('giro-ok'); return; }
  const adj=m=>[m[4]*m[8]-m[5]*m[7],m[2]*m[7]-m[1]*m[8],m[1]*m[5]-m[2]*m[4],m[5]*m[6]-m[3]*m[8],m[0]*m[8]-m[2]*m[6],m[2]*m[3]-m[0]*m[5],m[3]*m[7]-m[4]*m[6],m[1]*m[6]-m[0]*m[7],m[0]*m[4]-m[1]*m[3]];
  const mul=(a,b)=>{const c=[];for(let i=0;i<3;i++)for(let j=0;j<3;j++){let s=0;for(let k=0;k<3;k++)s+=a[3*i+k]*b[3*k+j];c[3*i+j]=s;}return c;};
  const mv=(m,v)=>[m[0]*v[0]+m[1]*v[1]+m[2]*v[2],m[3]*v[0]+m[4]*v[1]+m[5]*v[2],m[6]*v[0]+m[7]*v[1]+m[8]*v[2]];
  const basis=p=>{const m=[p[0][0],p[1][0],p[2][0],p[0][1],p[1][1],p[2][1],1,1,1];const v=mv(adj(m),[p[3][0],p[3][1],1]);return mul(m,[v[0],0,0,0,v[1],0,0,0,v[2]]);};
  const m3d=(src,dst)=>{const t=mul(basis(dst),adj(basis(src)));const m=t.map(v=>v/t[8]);return `matrix3d(${m[0]},${m[3]},0,${m[6]},${m[1]},${m[4]},0,${m[7]},0,0,1,0,${m[2]},${m[5]},0,1)`;};
  const FQ = [[112,96],[663,96],[663,397],[112,397]];      // pantalla en x-n5f (776×464)
  const LQ = [[57,80],[486,50],[480,388],[48,382]];        // pantalla en x-n5-off (776×589)
  const lado = new Image(); lado.className = 'nv-img nv-lado'; lado.dataset.var = '5'; lado.alt = ''; lado.src = 'x-n5-off.webp';
  const ease = t => t < .5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2;
  let src, ini, fin, base = '';
  const preparar = () => {
    const W = img.offsetWidth, hf = W * 464 / 776, hl = W * 589 / 776, k = W / 776, s = 1.13, tx = W * .156, ty = W * .215;
    // todo en coordenadas de la caja de la frontal (antes de su translate 0 9 %)
    src = FQ.map(([x,y]) => [x*k, y*k]);
    fin = src;
    ini = LQ.map(([x,y]) => [tx + s*x*k, (hf - hl) + ty + s*y*k - .09*hf]);
    lado.style.translate = tx + 'px ' + ty + 'px';
    const bt = getComputedStyle(img).transform; base = bt && bt !== 'none' ? bt + ' ' : ''; // conserva su centrado propio
    img.style.setProperty('transform-origin', '0 0', 'important');
    img.style.setProperty('transform', base + m3d(src, ini), 'important');
  };
  const correr = () => {
    duo.classList.add('girando'); lado.classList.add('sale');
    const t0 = performance.now(), D = 2400;
    const paso = now => { const e = ease(Math.min((now - t0) / D, 1));
      const q = ini.map((p, i) => [p[0] + (fin[i][0] - p[0]) * e, p[1] + (fin[i][1] - p[1]) * e]);
      img.style.setProperty('transform', base + m3d(src, q), 'important');
      if (e < 1) requestAnimationFrame(paso); else { lado.remove(); listo(); } };
    requestAnimationFrame(paso);
  };
  const arrancar = () => { preparar(); img.after(lado); requestAnimationFrame(() => requestAnimationFrame(() => lado.classList.add('ver'))); setTimeout(correr, 1500); };
  // v25: sin vista de lado. La pantalla aparece de frente (fundido suave) y enseguida arranca POWER.
  const ok = () => setTimeout(() => { duo.classList.add('girando'); setTimeout(listo, 700); }, 200);
  img.complete ? ok() : img.addEventListener('load', ok, { once: true });
  setTimeout(listo, 3000);
})();

} catch (e) { console.error(e); }
try {

// v27: centra el producto (y la marca NAVPRO) en el punto medio exacto de los 4 puntos rojos.
(() => {
  const duo = document.querySelector('.nv-duo'), img = duo && duo.querySelector('img[data-var="5"]'), ds = duo ? [...duo.querySelectorAll('.hs .hs-d')] : [];
  if (!img || ds.length !== 4) return;
  let x = 0, y = 0, ocupado = false;
  const centrar = () => {
    if (ocupado) return;
    const fr = duo.getBoundingClientRect(), r = img.getBoundingClientRect();
    if (r.width < 40) return;
    const c = ds.map(d => d.getBoundingClientRect()), cx = c.reduce((a, b) => a + b.left + b.width / 2, 0) / 4, cy = c.reduce((a, b) => a + b.top + b.height / 2, 0) / 4;
    const dx = cx - (r.left + r.width / 2), dy = cy - (r.top + r.height / 2);
    duo.style.setProperty('--wy', ((cy - fr.top) / fr.height * 100) + '%');
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1) { listoCentro(); return; }
    x += dx; y += dy; img.style.setProperty('--nx', x + 'px'); img.style.setProperty('--ny', y + 'px');
    ocupado = true; dispatchEvent(new Event('resize')); ocupado = false; // la pantalla viva se vuelve a encajar
    listoCentro();
  };
  // v29: el producto solo se muestra cuando ya quedó centrado; luego pasa un reflejo solo sobre él
  const listoCentro = () => {
    if (duo.classList.contains('centrado')) return;
    duo.classList.add('centrado');
    const b = document.createElement('i'); b.className = 'nv-brillo'; b.setAttribute('aria-hidden', 'true'); duo.appendChild(b);
    setTimeout(() => { const fr = duo.getBoundingClientRect(), r = img.getBoundingClientRect();
      Object.assign(b.style, { left: (r.left - fr.left) + 'px', top: (r.top - fr.top) + 'px', width: r.width + 'px', height: r.height + 'px' });
      b.classList.add('va'); setTimeout(() => b.remove(), 1600); }, 750);
  };
  setTimeout(listoCentro, 2500); // por si algo falla, que el producto no quede oculto
  addEventListener('resize', centrar);
  img.complete ? centrar() : img.addEventListener('load', centrar, { once: true });
  setTimeout(centrar, 300); setTimeout(centrar, 1200); document.addEventListener('nv:modelo', () => setTimeout(centrar, 50));
})();

} catch (e) { console.error(e); }
try {

// v32: resalta el punto que corresponde a lo que muestra la pantalla viva (ruta o música).
(() => {
  const scr = document.querySelector('.nv-scr'), hs = [...document.querySelectorAll('.nv-duo .hs')]; if (!scr || !hs.length) return;
  const mapa = { mapa: 'ruta', musica: 'musica', llamada: 'llamadas', llantas: 'llantas' };
  const marcar = () => { const a = mapa[scr.dataset.app]; hs.forEach(h => h.classList.toggle('vivo', !!a && h.dataset.app === a)); };
  const sub = document.querySelector('.nt-sub');
  const frase = () => { const t = ts.find(x => x.dataset.app === scr.dataset.app); if (!sub || !t) return; const txt = t.querySelector('span').childNodes[1].textContent; sub.classList.add('cambia'); setTimeout(() => { sub.textContent = txt; sub.classList.remove('cambia'); }, 300); };
  new MutationObserver(() => { marcar(); frase(); }).observe(scr, { attributes: true, attributeFilter: ['data-app'] }); marcar(); frase();
})();

} catch (e) { console.error(e); }
try {

// v36: llamada entrante → contesta sola a los 1,6 s → contador de tiempo.
(() => {
  const scr = document.querySelector('.nv-scr'); if (!scr) return; let t1, t2;
  const tm = scr.querySelector('.cl-time');
  new MutationObserver(() => {
    if (scr.dataset.app !== 'llamada') { scr.classList.remove('cl-on'); clearTimeout(t1); clearInterval(t2); return; }
    if (t1 && scr.dataset._cl === '1') return; scr.dataset._cl = '1';
    scr.classList.remove('cl-on'); tm.textContent = '00:00'; clearTimeout(t1); clearInterval(t2);
    t1 = setTimeout(() => { scr.classList.add('cl-on'); let n = 0; t2 = setInterval(() => { n++; tm.textContent = '00:0' + Math.min(n, 9); }, 1000); }, 1600);
  }).observe(scr, { attributes: true, attributeFilter: ['data-app'] });
  new MutationObserver(() => { if (scr.dataset.app !== 'llamada') delete scr.dataset._cl; }).observe(scr, { attributes: true, attributeFilter: ['data-app'] });
})();

} catch (e) { console.error(e); }
try {

// v37: la tarjeta del momento se resalta y su línea roja avanza mientras dura ese turno.
(() => {
  const scr = document.querySelector('.nv-scr'), ts = [...document.querySelectorAll('.nv-tabs .nt')]; if (!scr || !ts.length) return;
  const DUR = { mapa: 6800, musica: 3000, llamada: 4600, llantas: 4200 };
  const marcar = () => { const a = scr.dataset.app; ts.forEach(t => { const on = t.dataset.app === a; if (on) { t.classList.remove('on'); void t.offsetWidth; t.style.setProperty('--dur', (DUR[a] || 4000) + 'ms'); } t.classList.toggle('on', on); }); };
  const sub = document.querySelector('.nt-sub');
  const frase = () => { const t = ts.find(x => x.dataset.app === scr.dataset.app); if (!sub || !t) return; const txt = t.querySelector('span').childNodes[1].textContent; sub.classList.add('cambia'); setTimeout(() => { sub.textContent = txt; sub.classList.remove('cambia'); }, 300); };
  new MutationObserver(() => { marcar(); frase(); }).observe(scr, { attributes: true, attributeFilter: ['data-app'] }); marcar(); frase();
})();

} catch (e) { console.error(e); }
try {

// v54: cada escenario tiene su propia secuencia (orientación: h,v · desmontar: h,off). Arranca al verse.
(() => {
  const DUR = { h: 2800, v: 3000, off: 4200 };
  document.querySelectorAll('.gr-stage').forEach(st => {
    const sec = st.closest('section'), ps = [...sec.querySelectorAll('.gr-steps span')], ORD = (st.dataset.ord || 'h,v').split(',');
    const dur = k => (k === 'h' && ORD.includes('off')) ? 1600 : DUR[k];
    let i = 0, t, corre = false;
    const pon = k => { st.dataset.st = k; ps.forEach(p => { const on = p.dataset.st === k; if (on) { p.classList.remove('on'); void p.offsetWidth; p.style.setProperty('--dur', dur(k) + 'ms'); } p.classList.toggle('on', on); }); };
    const paso = () => { pon(ORD[i]); t = setTimeout(() => { i = (i + 1) % ORD.length; paso(); }, dur(ORD[i])); };
    pon(ORD[0]);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting && !corre) { corre = true; paso(); } else if (!e.isIntersecting && corre) { corre = false; clearTimeout(t); } }), { threshold: .35 }).observe(st);
  });
})();

} catch (e) { console.error(e); }
try {

// v63: la animación de desmontar empieza desde cero cuando se ve y se pausa fuera de pantalla.
(() => {
  const sp = document.querySelector('.sp'), tx = document.querySelector('.sp-txt'); if (!sp) return;
  const els = [...sp.querySelectorAll('*'), ...(tx ? tx.querySelectorAll('span') : [])];
  const set = on => els.forEach(e => e.getAnimations().forEach(a => { if (on) { a.currentTime = 0; a.play(); } else a.pause(); }));
  requestAnimationFrame(() => set(false));
  new IntersectionObserver(es => es.forEach(e => set(e.isIntersecting)), { threshold: .4 }).observe(sp);
})();

} catch (e) { console.error(e); }
try {

// Etiquetas que se tocan: muestran un dato corto abajo del producto; se cierra sola a los 2,8 s.
(() => {
  const pop = document.querySelector('.hs-pop'); if (!pop) return; let t;
  const abrir = h => { document.querySelectorAll('.hs.act').forEach(x => x.classList.remove('act')); h.classList.add('act'); pop.textContent = h.dataset.info; pop.classList.add('on'); clearTimeout(t); t = setTimeout(() => { pop.classList.remove('on'); h.classList.remove('act'); }, 2800); };
  document.querySelectorAll('.hs[data-info]').forEach(h => { h.addEventListener('click', () => abrir(h)); h.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(h); } }); });
})();

} catch (e) { console.error(e); }
try {
/* v83: el punto del sello queda justo en el borde derecho de la página */
(function(){const b=document.querySelector('.nv-t2 .nv-badge');if(!b)return;
function ub(){b.style.setProperty('margin-left','0px','important');const r=b.getBoundingClientRect(),w=document.documentElement.clientWidth;b.style.setProperty('margin-left',(w-(r.left+r.width/2))+'px','important');}
addEventListener('load',ub);addEventListener('resize',ub);if(document.fonts)document.fonts.ready.then(ub);})();
} catch (e) { console.error(e); }
try {
/* v91: las líneas rojas del hero siguen la altura del precio */
(function(){const h=document.querySelector('.nv-hero'),b=document.querySelector('.nv-op.on b');if(!h||!b)return;
function ub(){const hr=h.getBoundingClientRect(),br=b.getBoundingClientRect();const bd=document.querySelector('.nv-t2 .nv-badge');if(bd)h.style.setProperty('--bdy',Math.round(bd.getBoundingClientRect().bottom-hr.top)+'px');h.style.setProperty('--pry',Math.round(br.top-hr.top+br.height/2-30)+'px');}
addEventListener('load',ub);addEventListener('resize',ub);if(document.fonts)document.fonts.ready.then(ub);})();
} catch (e) { console.error(e); }
try {

/* v71 · los videos del problema arrancan solo cuando se ven */
(function () {
  const vs = document.querySelectorAll('.pb-v video'); if (!vs.length) return;
  if (!('IntersectionObserver' in window)) { vs.forEach(v => { v.preload = 'auto'; v.play().catch(() => {}); }); return; }
  const io = new IntersectionObserver(es => es.forEach(e => { const v = e.target; if (e.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); } }), { threshold: .4 });
  vs.forEach(v => io.observe(v));
})();

} catch (e) { console.error(e); }
try {

/* v107 · hilo conductor entre secciones */
(function () {
  const ss = document.querySelectorAll('.panel > .sec'); if (!ss.length) return;
  const hs = [...ss].map(sec => { const h = document.createElement('i'); h.className = 'hilo'; h.setAttribute('aria-hidden', 'true'); sec.prepend(h); return h; });
  if (!('IntersectionObserver' in window)) { hs.forEach(h => h.classList.add('vis')); return; }
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('vis'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -15% 0px' });
  hs.forEach(h => io.observe(h));
})();

} catch (e) { console.error(e); }
try {

/* v120 · los metros del giro van bajando en la pantalla vertical */
(function () { const m = document.querySelector('.cpx-m'); if (!m) return; let v = 260;
  setInterval(() => { v -= 10; if (v < 40) v = 260; m.textContent = v; }, 900); })();

} catch (e) { console.error(e); }
try {

/* v124 · «suspiro» en negro solo a mitad del giro (horizontal ⇄ vertical); al cargar arranca normal en horizontal, sin negro */
(function () {
  const st = document.querySelector('.gr-stage'), scr = st && st.querySelector('.gr-scr'); if (!scr) return;
  let prev = st.getAttribute('data-st'), t1, t2; scr.classList.toggle('vert', prev === 'v');
  new MutationObserver(() => {
    const now = st.getAttribute('data-st');
    if (now === prev) return;
    const gira = (prev === 'h' && now === 'v') || (prev === 'v' && now === 'h');
    prev = now; if (!gira) return;
    scr.classList.remove('suspiro2'); void scr.offsetWidth; scr.classList.add('suspiro2');
    clearTimeout(t1); clearTimeout(t2);
    t2 = setTimeout(() => scr.classList.toggle('vert', now === 'v'), 550);
    t1 = setTimeout(() => scr.classList.remove('suspiro2'), 1200);
  }).observe(st, { attributes: true, attributeFilter: ['data-st'] });
})();

} catch (e) { console.error(e); }
try {

/* v130 · el número 01/02 se alinea con la fila del selector Horizontal · Vertical */
(function () {
  const st = document.querySelector('.gr-sec .gr-stage'), n = st && st.querySelector('.gr-num'), tabs = document.querySelector('.gr-sec .gr-steps');
  if (!n || !tabs) return;
  const ub = () => { const a = st.getBoundingClientRect(), b = tabs.getBoundingClientRect(); st.style.setProperty('--gn-top', (b.top + b.height / 2 - a.top) + 'px'); };
  addEventListener('load', ub); addEventListener('resize', ub); if (document.fonts) document.fonts.ready.then(ub); ub();
})();

} catch (e) { console.error(e); }
(function(){var c=document.querySelector('.kitcar');if(!c)return;var im=[].slice.call(c.querySelectorAll('img'));
im.forEach(function(i){var s=i.getAttribute('src');if(s&&s.indexOf('width=')<0&&s.indexOf('.svg')<0){i.setAttribute('src',s+(s.indexOf('?')<0?'?':'&')+'width=640');}});
var go=function(){im.forEach(function(i){i.loading='eager';});};
if('IntersectionObserver' in window){var o=new IntersectionObserver(function(e){if(e[0].isIntersecting){go();o.disconnect();}},{rootMargin:'1600px 0px'});o.observe(c);}else go();})();
